const isObjectDeepEquals = (obj1, obj2) => {
  // Verificar se os objetos são do mesmo tipo e se não são nulos
  if (obj1 === obj2) {
    return true;
  }

  // Verificar se ambos são objetos e não nulos
  if (
    typeof obj1 !== 'object' ||
    obj1 === null ||
    typeof obj2 !== 'object' ||
    obj2 === null
  ) {
    return false;
  }

  // Obter as chaves dos objetos
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // Verificar se possuem a mesma quantidade de chaves
  if (keys1.length !== keys2.length) {
    return false;
  }

  // Verificar recursivamente cada chave e valor
  for (const key of keys1) {
    if (!keys2.includes(key) || !isObjectDeepEquals(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
};

export default isObjectDeepEquals;
